module.exports = __webpack_public_path__ + "static/media/tech-structured-3.162643bb.png";